import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import { RouterLinks } from '../../constants';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { PolicyService } from 'src/app/modules/policy/services/policy.service';
import { UserStore } from 'src/app/modules/authentication/state/user.store';
import { DocumentService } from '../../documentation/services/document.service';
import { PolicyStore } from 'src/app/modules/policy/state/policy.store';
import { PolicyQuery } from 'src/app/modules/policy/state/policy.query';
import { StorageService } from '../../services/storage.service';


declare var $: any;
declare var accounting: any;
declare function notify(): any;
declare function initPolicyOverviewTabs(): any;
declare function initNavPositioning(): any;
declare function Sidesheet(selector: any, options: any): any;

enum Entity {
  Policy = 'Policy',
  Item = 'Item',
  Vap = 'Vap'
}

@Component({
    selector: 'app-policy-documents',
    templateUrl: './policy-documents.component.html',
    styleUrls: ['./policy-documents.component.scss'],
    standalone: false
})
export class PolicyDocumentsComponent implements OnInit, AfterViewInit {


  policyId = '';
  selectedEntity = Entity.Policy;
  RouterLinks = RouterLinks;
  inProgress = environment.inProgress;
  person: any;
  policies: any;
  categories: any = [];
  documents: any;
  insurers: any = [];
  classes: any = [];
  dataset: any = [];
  constructor(
    public router: Router,
    private userStore: UserStore,
    private documentService: DocumentService,
    private policyStore: PolicyStore,
    private policyQuery: PolicyQuery,
    private policyService: PolicyService,
    private storageService: StorageService,
  ) {
    
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      $('#app-bar-desktop').find('#more').addClass('is-active');
       $('#overview-sub-3').removeClass('d-none');
       $('#overview-sub-3 .navbar-sub__nav').html('Policy documents');
        $('.navbar-sub__more').removeClass('d-none');
       // 
        // filters sidesheet
        // 
      //   const filtersSidesheet =  Sidesheet('#filters-sidesheet', {
      //     onOpen: () => {
      //         // optional 'onOpen' callback
      //     },
      //     onClose: () => {
      //         // optional 'onClose' callback
      //     }
      // }
      // );


      // // trigger sidesheet open      
      // $('[data-sidesheet-trigger="filters"]').on('click', function (e) {
      //     filtersSidesheet.openSidesheet(e);
      // });

      // // trigger sidesheet close on filter apply button click
      // $('#filters-apply-btn').on('click', function (e) {
      //     e.preventDefault();
      //     filtersSidesheet.closeSidesheet();
      // });

      

      // // demo enable/disable filter apply button
      // // if any input within #filters-sidesheet is checked, enable apply button
      // $('#filters-sidesheet input').on('change', function () {
      //     if ($('#filters-sidesheet input:checked').length) {
      //         $('#filters-apply-btn').removeClass('button--disabled');
      //     } else {
      //         $('#filters-apply-btn').addClass('button--disabled');
      //     }
      // });

      // // demo reset filters
      // $('#filters-reset-btn').on('click', function (e) {
      //     e.preventDefault();
      //     $('#filters-sidesheet input').prop('checked', false);   
      // });

      // // demo show number of filters selected
      // $('#filters-apply-btn').on('click', function (e) {
      //     $('#filters-trigger')
      //         .removeClass('is-empty')
      //         .find('span').text('5');
      // });
    }, 2000);
  }

  ngOnInit(): void {
    this.person = this.userStore.getValue();
    this.getPolicies();
  }
  // For a broker/console session, this.person is the broker's own login identity —
  // it has no policies of its own, so the documents list must be scoped to the
  // policyholder on the active policy instead (same convention as policy-overview-edit,
  // which reads this.person from policy.person[0] rather than the logged-in user).
  // Regular customers have no "active policy" here (this page is reached from the
  // general Documents hub, not a policy's own page), so they fall back to their own id.
  getPersonId(): any {
    const isBrokerOrConsole = this.person?.broker_id > 0 || this.person?.console_access;
    if (!isBrokerOrConsole) return this.person?.person_id;
    let activePersons = this.policyQuery.getActive()?.person;
    if (typeof activePersons === 'string') {
      try { activePersons = JSON.parse(activePersons); } catch { activePersons = undefined; }
    }
    return activePersons?.[0]?.person_id ?? this.person?.person_id;
  }
  getPolicies(): void {
    this.policyService.getPolicies(this.getPersonId(), this.person?.broker_id)
      .subscribe((policies: any[]) => {
        if (policies?.length) {
          this.policies = policies;
          this.dataset = policies;
          this.policies.forEach(cat => {
              if (this.categories.filter( c => c.category_id === cat.product_category_id).length === 0){
                this.categories.push({category_id: cat.product_category_id, category_name: cat.category_name});
              }
              if (this.insurers.filter( c => c.insurer_id === cat.insurer_id).length === 0){
                this.insurers.push({insurer_id: cat.insurer_id, logo: cat.underwriter_logo});
              }
              try{
                cat.documents = JSON.parse(cat?.documents);
                cat.documents = cat?.documents.filter( d => d.document_type === 'Policy Documents');
              }
              catch{}
              try{
                let classes = JSON.parse(cat?.classes);
                classes.forEach(c => {
                  if (this.classes.filter( cl => cl.class_id === c.class_id).length === 0){
                    this.classes.push({class_id: c.class_id, class_name: c.product_class});
                  }
                })
              }
              catch{}
              
          });
         console.log(this.policies);
         console.log(this.classes);
        }
      })

      
  }
  getCategoryPolicies(id: number): any {
    return this.dataset.filter( p => p.product_category_id === id);
  }
  getCSS(c: string): string {
    return c?.substring(0, c?.indexOf('.')).toLowerCase();
  }
  openDocument(doc: any, policy: any): void {
    policy.benefits = JSON.parse(policy?.benefits);
    policy.categories = JSON.parse(policy?.categories);
    policy.parsedClasses = JSON.parse(policy?.classes);
    policy.collation = JSON.parse(policy?.collation);
    policy.included = JSON.parse(policy?.included);
    policy.invoices = JSON.parse(policy?.invoices);
    policy.person = JSON.parse(policy?.person);
    policy.parsedRatings = JSON.parse(policy?.ratings);
    this.policyStore.setActive(policy?.policy_id);
      const policies = [policy];
      this.policyStore.set(policies);
    this.storageService.set('previous-document-page', this.router.url, 'flow');
    if (doc.document_name === 'Policy Schedule') {
      let path = doc.document_url
        .toLowerCase()
        .replace('login/?returnurl=', '/');
        path = path.replace('policy-schedule', 'policy-pdf-schedule');
      this.router.navigate([`/${path}`], { state: { doc} });
    } else if (
      doc.document_name === 'Policy Schedule' ||
      doc.document_url.includes('policy-wording') ||
      doc.document_name === 'Record of Advice' ||
      doc.document_name === 'Policy Transcript' ||
      doc.document_name === 'Certificate of Cover' 
    ) {
      const path = doc.document_url
        .toLowerCase()
        .replace('login/?returnurl=', '/');
      //this.router.navigate([`/${path}`], { state: { doc, print, pdf } });
      this.router.navigateByUrl(path, { state: { doc} });
    } else if (doc.document_url.indexOf('http') > -1) {
      window.open(doc.document_url);
    } else if (doc.document_name.includes('Claims Transcript') ){
      let path = doc.document_url
        .toLowerCase()
        .replace('login/?returnurl=', '/');
        path = `${path}&print=&pdf=`
      this.router.navigateByUrl(path)
    }
    else {
      this.router.navigate(['/doc-document'], { state: { doc } });
    }
    
  }
  openSidesheet(): void{
    $('#filters-sidesheet').addClass('is-active');
    $('body').addClass('sidesheet-open'); 
  }
  closeSidesheet(): void{
    $('#filters-sidesheet').removeClass('is-active');
    $('body').removeClass('sidesheet-open'); 
  }
  applyFilters(): void{
    let selectedCategories = [];
    let selectedClasses = [];
    let selectedInsurers = [];
    $('.checkbox-category').each(function(index, element){
      if ($(element).is(':checked')){
        selectedCategories.push(element.id);
      }
    });
    if (selectedCategories.length === 0){
      this.dataset = this.policies;
    }
    else{
      this.dataset = this.policies.filter( p => selectedCategories.includes(p.product_category_id.toString()));
    }
    $('.checkbox-class').each(function(index, element){
      if ($(element).is(':checked')){
        selectedClasses.push(element.id);
      }
    });
    if (selectedClasses.length === 0){
      this.dataset = this.dataset;
    }
    else{
      this.dataset = this.dataset.filter( p => selectedClasses.includes( JSON.parse(p.classes)[0].class_id.toString()));
    }
    $('.checkbox-insurer').each(function(index, element){
      if ($(element).is(':checked')){
        selectedInsurers.push(element.id);
      }
    });
    if (selectedInsurers.length === 0){
      this.dataset = this.dataset;
    }
    else{
      this.dataset = this.dataset.filter( p => selectedInsurers.includes(p.insurer_id.toString()));
    }
    this.closeSidesheet();
    console.log(this.dataset);
  }
  resetFilters(): void{ 
    $('.checkbox-category').each(function(index, element){
      $(element).prop('checked', false);
    }
    );
    $('.checkbox-class').each(function(index, element){
      $(element).prop('checked', false);
    }
    );
    $('.checkbox-insurer').each(function(index, element){
      $(element).prop('checked', false);
    }
    );
    this.closeSidesheet();
    this.dataset = this.policies;
  }

}
